<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Redes sociais</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            { text: 'Início', disabled: false, to: '/home', exact: true },
                            { text: 'Redes sociais', disabled: true, exact: true },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" @click="save" :loading="saving">Salvar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">Links exibidos no rodapé do site</v-card-title>
                    <v-card-subtitle>Deixe em branco as redes que não devem aparecer. Use o endereço completo, começando com
                        https://.</v-card-subtitle>
                    <v-card-text>
                        <v-form ref="form">
                            <v-row>
                                <v-col v-for="network in networks" :key="network.key" cols="12" md="6">
                                    <v-text-field dense outlined v-model="values[network.key]" :label="network.label"
                                        :placeholder="network.placeholder" :prepend-inner-icon="network.icon"
                                        :rules="[httpsUrl]" :loading="loading" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: "SocialNetworks",

    data: () => ({
        loading: false,
        saving: false,
        values: {},
        networks: [
            { key: "social-instagram", label: "Instagram", icon: "mdi-instagram", placeholder: "https://instagram.com/..." },
            { key: "social-linkedin", label: "LinkedIn", icon: "mdi-linkedin", placeholder: "https://linkedin.com/company/..." },
            { key: "social-facebook", label: "Facebook", icon: "mdi-facebook", placeholder: "https://facebook.com/..." },
            { key: "social-youtube", label: "YouTube", icon: "mdi-youtube", placeholder: "https://youtube.com/@..." },
            { key: "social-whatsapp", label: "WhatsApp", icon: "mdi-whatsapp", placeholder: "https://wa.me/553100000000" },
        ],
    }),

    created() {
        this.load();
    },

    methods: {
        httpsUrl(value) {
            return !value || /^https:\/\/\S+$/i.test(value.trim()) || "Use um link começando com https://";
        },

        async load() {
            this.loading = true;
            try {
                const result = await axios.get("/api/admin/site-settings");
                this.values = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            try {
                const result = await axios.put("/api/admin/site-settings", { values: this.values });
                this.values = result.data.content;
                this.$dialog.notify.info("Redes sociais salvas", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
